import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

export const getManySettings = (params) => {
    const { pathsContext, ...rest } = params;
    const url = buildQueryString(rest, `${pathsContext.serverUrl}/settings`);

    return (dispatch) =>
        VerbFetch(url).then((body) => {
            dispatch({
                type: ACTIONS.GET_MANY_SETTINGS,
                payload: {
                    settings: body
                }
            });

            return body;
        });
};

export const getSetting = (params) => {
    const { settingId, pathsContext } = params;
    const url = `${pathsContext.serverUrl}/settings/${settingId}`;

    return (dispatch) =>
        VerbFetch(url).then((body) => {
            dispatch({
                type: ACTIONS.GET_SETTING,
                payload: {
                    body
                }
            });
        });
};

export const postSetting = (params) => {
    const { body, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_SETTING_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/settings`, {
            method: 'POST',
            body
        }).then((body) => {
            dispatch({
                type: ACTIONS.POST_SETTING_SUCCESS,
                payload: {
                    body
                }
            });
        });
    };
};

export const putSetting = (params) => {
    const { settingId, body, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_SETTING_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/settings/${settingId}`, {
            method: 'PUT',
            body
        }).then((body) => {
            dispatch({
                type: ACTIONS.PUT_SETTING_SUCCESS,
                payload: {
                    body
                }
            });
        });
    };
};
